__turbopack_context__.v({
  "cardItem": "CardItem-module__Er2SnW__cardItem",
});
